import { render } from "./ManageDocument.vue?vue&type=template&id=9cdde618&scoped=true"
import script from "./ManageDocument.vue?vue&type=script&lang=js"
export * from "./ManageDocument.vue?vue&type=script&lang=js"

import "./ManageDocument.vue?vue&type=style&index=0&id=9cdde618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cdde618"]])

export default __exports__